import ModelReviewInterface from "../../../interfaces/model/ModelReviewInterface";

export default function ReviewEstimateGraph({reviews} : {reviews: ModelReviewInterface[]}) {
    return (<ul>
        <li><p>5 звезд</p><i className="line"><i style={{width: '50%'}}></i></i><p>20</p></li>
        <li><p>4 звезды</p><i className="line"><i style={{width: '10%'}}></i></i><p>4</p></li>
        <li><p>3 звезды</p><i className="line"><i style={{width: '0%'}}></i></i><p>0</p></li>
        <li><p>2 звезды</p><i className="line"><i style={{width: '0%'}}></i></i><p>0</p></li>
        <li><p>1 звезда</p><i className="line"><i style={{width: '0%'}}></i></i><p>0</p></li>
    </ul>)
}